import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import type { FC } from 'react'
import { PageIdStylioCapsule2 } from './pages'

type TIdToPageMapStylioCapsule2 = Record<PageIdStylioCapsule2, TPageMapValue>

const createLazyPage = <TModule>(
  preload: () => Promise<TModule>,
  getComponent: (module: TModule) => FC,
): TPageMapValue => ({
  Component: lazy(() => preload().then((m) => ({ default: getComponent(m) }))),
  preload,
})

export const ID_TO_PAGE_MAP_STYLIO_CAPSULE2: TIdToPageMapStylioCapsule2 = {
  [PageIdStylioCapsule2.AGE_CAPSULE2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/AgeQuestion'),
  },
  [PageIdStylioCapsule2.URGE_CAPSULE2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule2/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capsule2/pages/urge/UrgePage'),
  },
  [PageIdStylioCapsule2.HAIR_COLOR_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioCapsule2.EYES_COLOR_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioCapsule2.JEWELRY_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/JewelryQuestion'
      ).then((m) => ({
        default: m.JewelryQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioCapsule2.BODY_SHAPE_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioCapsule2.STYLIO_TO_HELP_CAPSULE2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/StylioToHelp'),
  },
  [PageIdStylioCapsule2.TALL_CAPSULE2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/TallQuestion'),
  },
  [PageIdStylioCapsule2.WEIGHT_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/WeightQuestion'
      ).then((m) => ({
        default: m.WeightQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/WeightQuestion'),
  },
  [PageIdStylioCapsule2.URGE_2_CAPSULE2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule2/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioCapsule2.FEEL_ABOUT_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/FeelAboutQuestion'
      ).then((m) => ({
        default: m.FeelAboutQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/FeelAboutQuestion'),
  },
  [PageIdStylioCapsule2.PERCENTAGE_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/PercentageQuestion'
      ).then((m) => ({
        default: m.PercentageQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/PercentageQuestion'
      ),
  },
  [PageIdStylioCapsule2.SHOPPING_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/ShoppingQuestion'
      ).then((m) => ({
        default: m.ShoppingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioCapsule2.STYLE_MOST_MATTERS_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioCapsule2.FAVORITE_COLORS_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislike'
      ).then((m) => ({
        default: m.LikeOrDislikeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislike'),
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_11_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant11'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant11Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant11'
      ),
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_12_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant12'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant12Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant12'
      ),
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_13_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant13'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant13Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant13'
      ),
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_14_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages//likeOrDislike/LikeOrDislikeVariant14'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant14Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages//likeOrDislike/LikeOrDislikeVariant14'
      ),
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_15_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant15'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant15Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant15'
      ),
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_16_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant16'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant16Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant16'
      ),
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_17_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant17'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant17Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant17'
      ),
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_18_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant18'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant18Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant18'
      ),
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_19_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant19'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant19Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/likeOrDislike/LikeOrDislikeVariant19'
      ),
  },
  [PageIdStylioCapsule2.STYLES_FEEL_LIKE_YOU_CAPSULE2]: createLazyPage(
    () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/StylesFeelLikeYouQuestion'
      ),
    (m) => m.StylesFeelLikeYouQuestion,
  ),
  [PageIdStylioCapsule2.URGE_3_CAPSULE2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule2/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioCapsule2.BRAND_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/BrandQuestion'
      ).then((m) => ({
        default: m.BrandQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/questions/BrandQuestion'),
  },
  [PageIdStylioCapsule2.FIND_NEW_CLOTHES_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioCapsule2.NOTHING_TO_WEAR_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/NothingToWearQuestion'
      ),
  },
  [PageIdStylioCapsule2.OLD_CLOTHES_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/OldClothesQuestion'
      ).then((m) => ({
        default: m.OldClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/OldClothesQuestion'
      ),
  },
  [PageIdStylioCapsule2.COMBINE_CLOTHES_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/CombineClothesQuestion'
      ),
  },
  [PageIdStylioCapsule2.OPTIMIZE_BUDGET_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/questions/OptimizeBudgetQuestion'
      ),
  },
  [PageIdStylioCapsule2.URGE_4_CAPSULE2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule2/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioCapsule2.PREPARE_FLOW_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/prepareFlow/PrepareFlow'
      ).then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioCapsule2.EMAIL_CAPSULE2]: createLazyPage(
    () => import('nove8/cohorts/stylio_capsule2/pages/email/Email'),
    (m) => m.Email,
  ),
  [PageIdStylioCapsule2.EMAIL_CONSENT_CAPSULE2]: createLazyPage(
    () => import('nove8/cohorts/stylio_capsule2/pages/email/EmailConsent'),
    (m) => m.EmailConsent,
  ),
  [PageIdStylioCapsule2.SUBSCRIPTIONS_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylioCapsule2.CANCEL_OFFER_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/cancel-offer/CancelOffer'
      ).then((m) => ({
        default: m.CancelOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioCapsule2.SUB_UPSELL_CAPSULE2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule2/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule2/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCapsule2.UPSELL_CAPSULE2]: createLazyPage(
    () => import('nove8/cohorts/stylio_capsule2/pages/upsell/Upsell'),
    (m) => m.Upsell,
  ),
  [PageIdStylioCapsule2.ACCOUNT_NOVE8]: createLazyPage(
    () => import('nove8/modules/account/AccountNove8'),
    (m) => m.AccountNove8,
  ),
  [PageIdStylioCapsule2.DOWNLOAD_CAPSULE2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule2/pages/download-app/DownloadDefault'
      ),
  },
}
